import { imgPrefix } from '@/utils/imgPrefix';
import { Button } from 'darrius';
import Image from 'next/image';
import styles from '../FeedbackValidation.module.scss';
import Link from 'next/link';

export default function FeedbackValidationSuccessLiveness() {
  return (
    <div className={`${styles['wrapper-feedback']}`}>
      <p className={`${styles['main-title']}`}>Reconhecimento facial</p>

      <div className={`${styles['feedback']}`}>
        <Image
          src={imgPrefix(
            '/images/idwall/document-validation-success-liveness.svg'
          )}
          alt="Validação de documentos bem sucedida"
          width={164}
          height={192}
          quality={100}
        />

        <p className={`${styles['feedback-title']}`}>
          Imagem verificada com sucesso!
        </p>

        <span>Baixe o aplicativo no seu celular para seguir.</span>

        <Link href={'https://www.getninjas.com.br/instale'}>
          <Button.Root
            type="button"
            variation="primary"
            className={`${styles['feedback-button']}`}
          >
            Fazer download do aplicativo
          </Button.Root>
        </Link>
      </div>
    </div>
  );
}
